import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const BASE_URL = 'https://www.vaguedemots.fr';
export const pages: Record<string, { title: string; description: string }> = {
  '/': {
    title: 'Lectrice-correctrice de manuscrits | Vague de Mots',
    description: 'Relecture, analyse et correction de manuscrits : Vague de Mots accompagne les auteurs et autrices avec rigueur, bienveillance et respect de leur style.',
  },
  '/prestations': {
    title: 'Relecture et correction de manuscrits | Vague de Mots',
    description: 'Découvrez les prestations de Vague de Mots : lecture critique, analyse de manuscrits, accompagnement à la réécriture et correction de vos textes.',
  },
  '/presentation': {
    title: 'Votre lectrice-correctrice | Vague de Mots',
    description: 'Découvrez Vague de Mots, un accompagnement attentif et bienveillant pour les auteurs et autrices souhaitant améliorer leurs manuscrits.',
  },
  '/tarifs': {
    title: 'Tarif correction de manuscrit et roman | Vague de Mots',
    description: 'Consultez les tarifs des prestations de lecture, analyse et correction de manuscrits proposées par Vague de Mots.',
  },
  '/contact': {
    title: 'Contacter votre lectrice-correctrice | Vague de Mots',
    description: 'Vous souhaitez faire relire, analyser ou corriger votre manuscrit ? Contactez Vague de Mots pour échanger sur votre projet.',
  },
  '/mentions-legales': {
    title: 'Mentions légales | Vague de Mots',
    description: 'Retrouvez les mentions légales du site Vague de Mots.',
  },
  '/politique-de-confidentialite': {
    title: 'Politique de confidentialité | Vague de Mots',
    description: 'Consultez la politique de confidentialité du site Vague de Mots et les informations relatives aux données personnelles.',
  },
};

function setMeta(attribute: 'name' | 'property', key: string, content: string) {
  let element = document.querySelector<HTMLMetaElement>(
    `meta[${attribute}="${key}"]`
  );

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = pages[pathname];
    const title = page?.title ?? 'Page introuvable | Vague de Mots';
    const description = page?.description ?? 'Vague de Mots, lectrice-correctrice.';
    const canonical = `${BASE_URL}${pathname}`;

    document.title = title;

    setMeta('name', 'description', description);
    setMeta('property', 'og:title', title);
    setMeta('property', 'og:description', description);
    setMeta('property', 'og:url', canonical);
    setMeta('property', 'og:type', 'website');

    let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');

    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }

    link.href = canonical;

    if (!page) {
      setMeta('name', 'robots', 'noindex, follow');
    } else {
      setMeta('name', 'robots', 'index, follow');
    }
  }, [pathname]);

  return null;
}
